module.exports = __webpack_public_path__ + "img/bg-dot.2f2ca4e.png";